import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { environment } from '../../environments/environment';
import { CommonService } from '../core/services/common.service';
import { BookADemoModal } from '../core/modals/bookADemo.modal';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Captcha } from 'primeng/captcha';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '../core/services/seo.service';


declare const $: any;
declare const jQuery: any;
declare const grecaptcha: any;

@Component({
  selector: 'app-book-demo',
  templateUrl: './book-demo.component.html',
  styleUrls: ['./book-demo.component.scss'],
})
export class BookDemoComponent implements OnInit {
  showPickASlot: boolean = false;
  showSuccess: boolean = false;
  bookADemoObj!: BookADemoModal;
  loader: boolean = false;
  emailPattern =
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  env = environment;
  isDomainValid = true;
  skillGroups: any[] = [];
  locations: any[] = [];
  acceptTerms: boolean = false;
  languageCode: string = "en";
  userDesignationId:any;
  @ViewChild('recaptcha') recaptcha: Captcha;  

  demoType = [
    { id: 1, name: 'I want to hire IT Talent' },
    { id: 2, name: 'I want my IT team to be hired by global customers' },
  ];
  platformApporachTypes = [
    { id: 1, name: 'A friend refered' },
    { id: 2, name: 'Google' },
    { id: 3, name: 'Email' },
    { id: 4, name: 'Website' },
    { id: 5, name: 'Social media' },
    { id: 6, name: 'Search engine' },
    { id: 7, name: 'Others' },
  ];
  noOfEmployees = [
    { id: 2, name: '1-5 Employees' },
    { id: 3, name: '6-10 Employees' },
    { id: 4, name: '11-20 Employees' },
    { id: 5, name: '21-50 Employees' },
    { id: 6, name: '51-100 Employees' },
    { id: 7, name: '101-250 Employees' },
    { id: 8, name: '251-500 Employees' },
    { id: 9, name: '501-1000 Employees' },
    { id: 10, name: '1001-2000 Employees' },
    { id: 11, name: '2001-3500 Employees' },
    { id: 12, name: '3500+ Employees' },
  ]
  designations = [];

  constructor(
    private commonService: CommonService,
    private ref: ChangeDetectorRef, private router:Router,
    private titleService: Title,
    private seo :SeoService, private translate : TranslateService,
    private translateService : TranslateService
  ) {
    this.bookADemoObj = new BookADemoModal();
    this.bookADemoObj.skillGroupIds = [];
  }
  foods = [{ viewValue: '1' }, { viewValue: '2' }, { viewValue: '3' }];

  bookdemoPathUrl: any;
  phonePrefixes:any =[];
  selectedPrefix :any;
  websiteUrl = environment.WEBSITE_URL;

  ngOnInit(): void {
    this.titleService.setTitle(this.translateService.instant('pageTitles.bookDemo'));
    
    this.getAllSkillGroups();
    this.bookdemoPathUrl = environment.imgpathUrl;
    $(() => {
      this.emailValidation();
      $('#bookADemoForm').validate({
        rules: {
          contactEmail: {
            emailValidation: true,
          },
        },
        errorPlacement: (error, element) => {
          if (element.attr("name") === "locationInfo") {
            error.insertAfter(element.closest('.error-text'));
          } else {
            error.insertAfter(element);
          }
        },
      });
    });
    //console.log(this.bookADemoObj);
    this.getPhonePrefixes();
    this.titleService.setTitle(this.translate.instant('Bookdemo.metaTitle'));
    this.seo.updateMetaTagsInformation(this.translate.instant('Bookdemo.metaTitle'),
     this.translate.instant('Bookdemo.metaDesc'), '', 'https://amy.pro/assets/images/book-demo/book-demo-banner-removebg-preview.png' , 'en/book-demo')
  }

  ngOnChanges(){
    this.setDesignationId()
  }

  public getAllSkillGroups() {
    this.commonService.getAllSkillGroups().subscribe((res: any) => {
      this.skillGroups = res.message;
    });
  }

  public onLocationSearch(event: any) {
    this.commonService.getCities(event.query).subscribe((res: any) => {
      this.locations = res.message.responseData;
      for (const loc of this.locations) {
        loc['formattedName'] =
          loc.cityName + ' - ' + loc.stateName + ' - ' + loc.countryName;
      }
    });
  }

  filterOptions(option: any, filterValue: string) {
    filterValue = filterValue.toLowerCase();
    return (
      option.phonePrefix.toLowerCase().includes(filterValue) ||
      option.countryName.toLowerCase().includes(filterValue)
    );
  }

  public onChangeSkillGroups(event: any) {
    if (this.bookADemoObj.skillGroupIds.length === 0) {
      $('#skillGroupsError').removeClass('d-none');
    } else {
      $('#skillGroupsError').addClass('d-none');
    }
  }

  public agreeTermsAndPolicy(value) {
     this.acceptTerms = value;
  }

  public validateCaptcha() {
    $('#recaptchaError').addClass('d-none');
    if (!grecaptcha.getResponse()) {
      $('#recaptchaError').removeClass('d-none');
    }
    return grecaptcha.getResponse() ? true : false;
  }

  public schedule() {
    //this.showPickASlot = true;
    $('#bookADemoForm').validate();
    this.onChangeSkillGroups(null);
    const isCaptchaVerified = this.validateCaptcha();
    if (
      !$('#bookADemoForm').valid() ||
      !this.isDomainValid ||
      this.bookADemoObj.skillGroupIds.length === 0 ||
      !isCaptchaVerified ||
      !this.acceptTerms
    ) {
      return;
    }
    this.showPickASlot = true;
  }

  public emailValidation() {
    const self = this;
    jQuery.validator.addMethod(
      'emailValidation',
      (value) => {
        const emailId: string = value.trim();
        const emailReg = new RegExp(self.emailPattern);
        if (emailReg.test(emailId)) {
          // const domain = emailId.split('@')[1];
          // const invalidDomains = ['gmail.com', 'yopmail.com']
          // if (invalidDomains.includes(domain)) {
          //   return false;
          // }
          this.validateEmailDomains();
          return true;
        } else {
          return false;
        }
      },
      'Please enter correct work email'
    );
  }

  public reset() {
    // location.reload();
    this.router.navigateByUrl('/en/connect');
  }

  timeout: any;
  home = { label: "Home", routerLink: "/en/connect" };
  items = [ { label: "Book a demo", routerLink: this.router.url } ];

  public validateEmailDomains() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.commonService
        .validateEmailDomains(this.bookADemoObj.email)
        .subscribe((res: any) => {
          this.isDomainValid = res;
          this.triggerChange();
        });
    }, 100);
  }

  // trigger the changes
  public triggerChange() {
    if (!this.ref['destroyed']) {
      this.ref.detectChanges();
    }
  }

  public slotEvent(event: any) {
    if (event.status) {
      this.loader = true;
      console.log( "STEKEY: " + this.env.CAPTCHA_SITE_KEY)
      this.bookADemoObj['recaptchaResponse'] = grecaptcha.getResponse();
      this.commonService.saveConnectDemoBooking(this.bookADemoObj).subscribe(
        (res: any) => {
          this.showSuccess = true;
          this.loader = false;
        },
        (err) => {
          // this.commonService.showToaster(err.message.errorMessage, 'error', 'Error');
          this.loader = false;
        }
      );
    } else {
      grecaptcha.reset();
      this.showSuccess = false;
      this.showPickASlot = false;
    }
  }

  public getPhonePrefixes(){
    this.commonService.getAllCountryPhoneNumPrefix().subscribe(res => {
      this.phonePrefixes = res.message
      this.bookADemoObj.phoneNumCountryCode = this.phonePrefixes[236]?.countryCode
      this.bookADemoObj.phoneNumberPrefix = this.phonePrefixes[236]?.phonePrefix
    });
  }

  onPrefixChange(event){
    this.bookADemoObj.phoneNumCountryCode = event.value
    this.bookADemoObj.phoneNumberPrefix = this.phonePrefixes
    this.selectedPrefix = this.phonePrefixes.find(
      (prefix) => prefix.countryCode === this.bookADemoObj.phoneNumCountryCode
    );
    if (this.selectedPrefix) {
      this.bookADemoObj.phoneNumberPrefix = this.selectedPrefix.phonePrefix;
    }
  }

  public onDesignationSearch($event: any) {
    let selectedsearchText = $event?.query
    this.commonService.getDesignations(selectedsearchText).subscribe(res => {
      this.designations = res.message;
      
    });
  }

  public setDesignationId() {
    //sconsole.log('called setDesignationId')
    if(this.userDesignationId){
    this.bookADemoObj.userDesignationId = this.userDesignationId.designationId;
    }
  }

  onItemClick(event) {
    if (event.item && event.item.routerLink) {
      this.router.navigateByUrl(event.item.routerLink);
    }
  }
}
